import controller from './input-kid.controller';
import template from './input-kid.html';

export default {
	template,
	bindings: {
		disabled:    '<?ngDisabled',
		placeholder: '@?',
		prefix:      '@?',
		required:    '<?ngRequired',
		onSelect:    '&?',
		options:     '<?',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
